import React from 'react';
import Loader from '../../components/common/Loader';
import Header from '../../components/innerpage/about/Header';
import Navbar from '../../components/innerpage/Navbar';
import About from '../../components/innerpage/about/About';
import Process from '../../components/home1/Process';
import Projects from '../../components/innerpage/about/Projects';
import Awards from '../../components/innerpage/about/Awards';
import Chat from '../../components/home1/Chat';
import Footer from '../../components/home1/Footer';
import Mission from '../../components/innerpage/about/Mission';
import Menu from '../../components/innerpage/Menu';
import Experience from '../../components/home1/Experience';
import { Helmet } from 'react-helmet';

function AboutPage() {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          type="text/css"
          href="/innerpages/assets/css/innerpages.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/home1/assets/css/home_1_style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/common/assets/css/common_style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/home_preview/assets/css/home_preview_style.css"
        />
        <script src="/common/assets/js/common_js.js"></script>
        <script src="/innerpages/assets/js/innerpages.js"></script>
      </Helmet>
      <body className="inner-pages-style1 about-pg-style1 home-style1 home-preview">
        <Loader />
        <Menu />
        <div className="smooth-scroll-content" id="scrollsmoother-container">
          <Navbar />
          <Header />
          <main>
            <Experience />
            <Process />
            <Chat />
          </main>
          <Footer />
        </div>
      </body>
    </>
  );
}

export default AboutPage;
